import { useQuery } from '@tanstack/react-query';
import { watchApi } from '../api/watchApi';
import type { WatchListResponse, ApiError } from '../types/showcase';

/** queue #677 §R677-3 공유 쿼리키 — WatchToggle · WatchedChangesCard(_index) · 트리 구독 필터가 공유 */
export const WATCHES_QUERY_KEY = ['showcase', 'watches'] as const;

/**
 * Query: GET /api/eraf/showcase/watches (queue #677 §UAT-2026-07-13-R677 §R677-3).
 * 인증-any(guest 포함) · 미인증은 401 → isError(호출부가 fail-soft 로 카드/토글 생략).
 * 부가 개인화 데이터라 실패해도 카탈로그/대시보드 본체를 막지 않는다(§R662 계보).
 */
export function useWatches() {
  return useQuery<WatchListResponse, ApiError>({
    queryKey: WATCHES_QUERY_KEY,
    queryFn: () => watchApi.list(),
    retry: false,
    staleTime: 30_000,
  });
}
